import { ChannelState } from 'stream-chat';
import { ChatFormatMessage, ChatNonFormatMessage } from './types';

export function formatChatMessage(message: ChatNonFormatMessage): ChatFormatMessage {
  return ChannelState.prototype.formatMessage(message);
}
